import { Entity } from '@/interfaces'
import model from './model'
import repository from './repository'

const travelServiceDateSwitchSettingsEntity: Entity = {
  model: model,
  repository: repository,
}

export default travelServiceDateSwitchSettingsEntity
